import React from 'react';
import { Errors, Form, useForm } from '/src/components';
import { cloudflareGetRecaptchaToken, cloudflareUseRecaptcha } from '/src/services';

const Reset = ({
    email,
    translate,
    isLoading,
    onSuccess,
    requestPasswordResetEmail,
    cloudflareSiteKey,
}) => {
    const {
        data,
        errors,
        setErrors,
        fieldsErrors,
        handleChange,
        validateData
    } = useForm(
        {
            email,
        },
        {
            email: { isRequired: true },
        }
    );
    const { cloudflareResetRecaptcha } = cloudflareUseRecaptcha(cloudflareSiteKey, '#cf-turnstile');

    const handleSubmitReset = e => {
        e.preventDefault();
        const isValidData = validateData();
        const { email } = data;

        const recaptchaToken = cloudflareGetRecaptchaToken();

        if (!recaptchaToken) {
            setErrors([{ message: 'Check recaptcha' }]);
        } else if (isValidData) {
            requestPasswordResetEmail({ email }, { 'cf-turnstile-response': recaptchaToken })
                .then(() => onSuccess('If an account exists for email, you`ll receive an email with a password reset link shortly. This may take a few minutes to arrive and please be sure to check your spam folder just in case!'))
                .catch(errors => {
                    cloudflareResetRecaptcha();
                    setErrors(errors);
                });
        }
    };

    return (
        <>
            <Errors errors={errors} translate={translate} />
            <Form onSubmit={handleSubmitReset}>
                <Form.Column mb>
                    <Form.Input
                        placeholder={translate('Enter your email')}
                        label={translate('Email')}
                        type="email"
                        name="email"
                        value={data.email}
                        onChange={handleChange}
                        error={translate(fieldsErrors.email)}
                    />
                </Form.Column>
                <div id="cf-turnstile" />
                <Form.Column mt>
                    <Form.Button disabled={isLoading}>
                        {translate('Submit')}
                    </Form.Button>
                </Form.Column>
            </Form>
        </>
    )
};

export default Reset;
